<template>
  <aha-modal
    @hide="hide()"
    :title="`${$i18nPresenter.t('Rename')}: ${presentation.name}`"
    action-position="justify-end"
  >
    <form @submit.prevent="handleRename()">
      <aha-input
        focus
        v-model="name"
        :maxLength="maxLength"
      />
    </form>
    <template #action>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
      <aha-button
        :disabled="isLoading"
        @click="handleRename()"
        has-margin-left
      >
        <aha-spinner variant="white" v-if="isLoading" class="mr-1" />
        {{ $i18nPresenter.t("Save") }}
      </aha-button>
    </template>
    <p class="pt-2 text-red-50" v-if="textError">
      {{ textError }}
    </p>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import * as Sentry from '@sentry/vue'
import PresentationApi from '@/api/presentation'

import Utils from '@/util'
import constants from '@/constant'

const { eventCategories } = constants

export default {
  props: {
    presentation: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
  },
  data() {
    return {
      name: this.presentation.name || '',
      maxLength: 100,
      isLoading: false,
      textError: '',
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
    }),
  },
  methods: {
    ...mapActions(['setErrorOnInternalServerAction']),
    async handleRename() {
      if (this.name.trim() === '') {
        this.textError = this.$i18nPresenter.t('Please enter a name for presentation.')
        return
      }

      if (this.name === this.presentation.name) {
        this.textError = this.$i18nPresenter.t('This is your current presentation name.')
        return
      }

      this.isLoading = true

      try {
        await PresentationApi.updatePresentationByPresentationId(
          this.presentation.id, {
            name: this.name,
          },
        )

        this.$store.state.presentations = this.$store.state.presentations.map((item) => {
          return item.id !== this.presentation.id
            ? item
            : {
              ...item,
              name: this.name,
            }
        })

        this.hide()
        Utils.showToastSuccess(`"${Utils.sanitize(this.presentation.name)}" ${this.$i18nPresenter.t('renamed to')} "${Utils.sanitize(this.name)}"`)
      } catch (error) {
        Sentry.captureException(error)
        this.setErrorOnInternalServerAction(`Cannot rename this presentation: ${Utils.sanitize(this.presentation.name)}`)
      } finally {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Rename > Changed')
      }

      this.isLoading = false
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
